import {
  ENTITY_COMMAND_TYPE,
  ENTITY_GET_BY_OBJECT_ID_COMMAND_TYPES,
  FIELD_VALUE_TYPE,
} from '@constants'
import { RequestParams } from '@types'

import { selectCommandForEntityAction } from './selectCommandForEntityAction'

type SelectCommandArgs = Parameters<typeof selectCommandForEntityAction>[0]
type EntityCommand = NonNullable<ReturnType<typeof selectCommandForEntityAction>>

type GetReadObjectCommandConfigArgs = {
  objectId: string
  typeId?: FIELD_VALUE_TYPE
  overrideCommands?: SelectCommandArgs['overrideCommands']
  objectCommands?: SelectCommandArgs['objectCommands']
}

type ReadObjectCommandConfig = {
  command: EntityCommand
  actionType: ENTITY_COMMAND_TYPE
  sourceParams: RequestParams
  defaultParams: RequestParams
}

const getReadCommandTypesByPriority = (typeId?: FIELD_VALUE_TYPE) => {
  if (typeId === FIELD_VALUE_TYPE.OBJ_INTERNAL_ID_LINK) {
    return [ENTITY_COMMAND_TYPE.GET_BY_INTERNAL_ID]
  }

  return ENTITY_GET_BY_OBJECT_ID_COMMAND_TYPES
}

const getDefaultReadParams = ({
  actionType,
  objectId,
}: {
  actionType: ENTITY_COMMAND_TYPE
  objectId: string
}): RequestParams => {
  if (actionType === ENTITY_COMMAND_TYPE.GET_BY_INTERNAL_ID) {
    return { objectInternalId: objectId }
  }

  if (actionType === ENTITY_COMMAND_TYPE.GET_BY_IDS) {
    return { ids: objectId }
  }

  return { objectId }
}

const getReadSourceParams = (objectId: string): RequestParams => {
  return {
    objectId,
    ids: objectId,
    objectInternalId: objectId,
  }
}

export const getReadObjectCommandConfig = ({
  objectId,
  typeId,
  overrideCommands,
  objectCommands,
}: GetReadObjectCommandConfigArgs): ReadObjectCommandConfig | null => {
  const commandTypes = getReadCommandTypesByPriority(typeId)

  for (const actionType of commandTypes) {
    const command = selectCommandForEntityAction({
      overrideCommands,
      objectCommands,
      actionType,
    })

    if (command) {
      return {
        command,
        actionType,
        sourceParams: getReadSourceParams(objectId),
        defaultParams: getDefaultReadParams({
          actionType,
          objectId,
        }),
      }
    }
  }

  return null
}
